<script lang="ts">
    import { getContext } from "svelte";
    import Button from "../shared/Button.svelte";
    import Icon from "../shared/Icon.svelte";
    import type { Writable } from "svelte/store";
    import type { State } from "../../types/state";
    import type { SourceConfig } from "../../../../../modules/vu-player-models/configuration/source-config";

    let state: Writable<State> = getContext("playerState");

    $: disabled = !$state.hasCanplayFired;
    $: type = ["uninitialised", "paused"].includes($state.playerState)
        ? "play"
        : ["playing", "waiting", "seeking"].includes($state.playerState)
        ? "pause"
        : ["error", "ended"].includes($state.playerState)
        ? "replay"
        : "";
    $: playPauseSuffix = type === "replay" ? "" : " (k)";
    $: label = type + playPauseSuffix;

    function onClick() {
        if (type === "play") {
            $state.adapter?.play();
        } else if (type === "pause") {
            $state.adapter?.pause();
        } else if (type === "replay") {
            if ($state.sourceConfig) {
                let srcConf = $state.sourceConfig as SourceConfig;
                $state.adapter?.load(srcConf);
            }
        }
    }
</script>

<Button on:click={onClick} {disabled} {label}>
    <Icon {type} {disabled} />
</Button>
